import { Auth } from 'aws-amplify';

const forceChangePassword = async ({ cognitoUser, password }) => {
  const user = await Auth.completeNewPassword(cognitoUser, password);
  // Set any permissions
  if (user.signInUserSession) {
    const { permissions = [] } = user.signInUserSession.idToken.payload;
    localStorage.setItem('permissions', permissions);
  }

  return user;
};

export default forceChangePassword;
